import React from 'react';
import Window from '../os/Window';

const WARNINGS = [
    { id: 'sleep', label: 'Sleep debt', value: 'Critical' },
    { id: 'caffeine', label: 'Caffeine intake', value: 'Too high' },
    { id: 'stress', label: 'Stress levels', value: 'Elevated' },
    { id: 'sanity', label: 'Sanity', value: 'Under question' },
];

const Health: React.FC<WindowAppProps> = (props) => {
    return (
        <Window
            top={100}
            left={100}
            width={320}
            height={260}
            windowTitle="Health"
            windowBarIcon="healthIcon"
            closeWindow={props.onClose}
            onInteract={props.onInteract}
            minimizeWindow={props.onMinimize}
        >
            <div style={styles.content}>
                <ul style={styles.list}>
                    {WARNINGS.map((w) => (
                        <li key={w.id} style={styles.listItem}>
                            <span style={styles.label}>{w.label}</span>
                            <span style={styles.value}>{w.value}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </Window>
    );
};

const styles: StyleSheetCSS = {
    content: {
        padding: 16,
        fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, sans-serif',
        fontSize: 12,
        color: '#e8e8e8',
        overflow: 'auto',
        minWidth: 0,
        boxSizing: 'border-box',
    },
    list: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
    },
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 12,
        padding: '6px 0',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        minWidth: 0,
    },
    label: {
        flexShrink: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    value: {
        fontWeight: 500,
        color: '#ff8a7a',
        fontSize: 11,
        flexShrink: 0,
    },
};

export default Health;
